import React from 'react';

export default function SadRobot(props) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 447 363" version="1.1" {...props} >
        <g id="sad" transform="translate(-377.000000, -219.000000)" fill="#FFFFFF">
            <path d="M776,367 L797.988435,367 L824,445.5 L797.988435,524 L776,524 L776,367 Z M403.010835,367 L425,367 L425,524 L403.010835,524 L377,445.5 L403.010835,367 Z M439,551.768394 L439,379.148243 C439,290.700979 511.082687,219 600.00081,219 C688.917313,219 761,290.700979 761,379.148243 L761,551.768394 L730.607453,582 L469.392547,582 L439,551.768394 Z M707.189262,421 C713.13533,421 718,416.136229 718,410.19126 L718,377.807122 C718,371.863771 713.13533,367 707.189262,367 L493.809119,367 C487.86467,367 483,371.863771 483,377.807122 L483,410.19126 C483,416.136229 487.86467,421 493.809119,421 L707.189262,421 Z M694,530.5 C694,492.724092 651.040959,464 599.5,464 C547.959041,464 505,492.724092 505,530.5 C505,536.022847 509.477153,540.5 515,540.5 C520.522847,540.5 525,536.022847 525,530.5 C525,505.867731 557.704837,484 599.5,484 C641.295163,484 674,505.867731 674,530.5 C674,536.022847 678.477153,540.5 684,540.5 C689.522847,540.5 694,536.022847 694,530.5 Z" id="Combined-Shape" />
        </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/vectors/SadRobot.js